import {
  instanceOfAuthTokenResponse,
  Login200Response,
  Unauthorized,
} from '@/services/Api/generated'

export const isAuthTokenResponseSuccess = (
  response: Login200Response | Unauthorized
): response is Login200Response => {
  return (
    response.status === true &&
    'data' in response &&
    response.data != null &&
    instanceOfAuthTokenResponse(response.data)
  )
}
